// extracted by mini-css-extract-plugin
export var divider = "_uw-0";